const GENERIC = 'Common.errorAction'

const ERROR_KEY = /^[a-z][a-z0-9_]*$/

function humanize (key) {
  const sentence = key.replace(/_/g, ' ')
  return sentence.charAt(0).toUpperCase() + sentence.slice(1)
}

export default {
  install (Vue) {
    Vue.prototype.$apiErrorMessage = function (message) {
      if (typeof message !== 'string' || !message) return null

      const path = `Common.error.${message}`
      if (this.$te(path)) return this.$t(path)

      return ERROR_KEY.test(message) ? humanize(message) : message
    }

    Vue.prototype.$toastError = function (err, fallback = GENERIC) {
      if (err && err.handled) return
      this.$toast.error(this.$t(fallback))
    }

    Vue.prototype.$toastApiError = function (err, fallback = GENERIC) {
      if (err && err.handled) return
      this.$toast.error(this.$apiErrorMessage(err?.response?.data?.message) ?? this.$t(fallback))
    }
  }
}
